import { AxiosInstance } from 'axios';
import CommonCRUD from "../../../CommonCRUD";

export class LimitsApi extends CommonCRUD {
    api: AxiosInstance;

    schema = 'limits';

    constructor(api) {
        super(api);
        this.api = api;
    }

  async createLimit(id, data) {
        console.log('createLimit!', id);
    return await this.api.fetch({
      method: 'post',
      url: `/${this.schema}/customer/${id || ''}`,
      data,
    });
  }
  async get(id) {
    return await this.api.fetch({
      method: 'get',
      url: `/${this.schema}/customer/${id}`,
      ignoreErrorMessage: true
    });
  }
}

export default LimitsApi;
